import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body email-verify" }
const _hoisted_6 = { class: "row g-3" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexTwofactor',
  setup(__props) {

const twofactorAuthentication = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/twofactorAuthentication.vue"))
const emailVerification = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/emailVerification.vue"))
const verificationCode = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/verificationCode.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Layout",
      title: "Two Factor"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(twofactorAuthentication)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(emailVerification)),
                _createVNode(_unref(verificationCode))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})